import WarrantyPage from './warranty.container';

export default WarrantyPage;